// leaveDetailsApi.js

import axios from "axios";
import { Base_URL } from "../url";

export const getLeavesData = async (userId, orgId, token) => {
  const response = await axios.get(
    `${Base_URL}/Leave/GetLeavesData`,
    {
      params: {
        userId,
        orgId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const changeLeaveStatus = async (
  leaveGuid,
  activity,
  approvedBy
) => {
  return await axios.post(
    `${Base_URL}/Leave/ChangeLeaveStatus?leaveGuid=${leaveGuid}&activity=${activity}&approvedBy=${approvedBy}`
  );
};